import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\">\n<path d=\"M4.19957 12.6051L3.42773 11.8L7.21107 7.99995L3.42773 4.16662L4.19957 3.36145L8.01623 7.19478L11.7996 3.36145L12.5714 4.16662L8.78807 7.99995L12.5714 11.8L11.7996 12.6051L8.01623 8.77178L4.19957 12.6051Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol